module.exports = __webpack_public_path__ + "img/Scan-QR-code.5f2c3554.png";